<template>
<!-- 幸运购活动 -->
<div class="viewContainer">
  <div v-show="isOrder" @listenEdit="showOrder">
    <!-- 搜索/查询 -->
    <div class="main_container">
      <div class="fuji" @click="show3 = !show3">
        <div class="goodslist1">
          <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
          <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
        </div>
        <div style="position: absolute;right:0;top:-10px" class="sanjiao"/>
      </div>
      <el-collapse-transition>
        <div v-show="show3">
          <el-form :inline="true" :model="filters" style="display:flex;" class="findform">
            <!-- 顶部搜索框 -->
            <el-form-item style="display:flex;width:30%" label="活动ID：">
              <el-input v-model="filters.flexibleCode" placeholder="输入活动ID" maxlength="20" style="width:90%;"/>
            </el-form-item>
            <el-form-item style="display:flex;width:30%" label="商品名称：">
              <el-input v-model="filters.goodsName" placeholder="商品名称" maxlength="20" style="width:90%;"/>
            </el-form-item>
            <el-form-item style="display:flex;width:30%" label="活动时间：">
              <el-date-picker type="date" v-model="filters.strStart" :editable="false" value-format="yyyy-MM-dd"
              placeholder="选择时间" style="width:90%;"/>
            </el-form-item>
            <!-- <el-form-item style="display:flex;width:25%;" label="活动模式：" class="select">
              <el-select v-model="filters.eventMode" filterable placeholder="请选择" style="width:100%">
                <el-option v-for="(item,index) in activityModeArr" :key="index" :label="item.Name" :value="item.Id"/>
              </el-select>
            </el-form-item> -->
            
            <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
          </el-form>
        </div>
      </el-collapse-transition>
    </div>
    <!--列表-->
    <div class="main_container">
      <div class="model_section">
        <p class="model_top_title">幸运购活动</p>
        <div style="float: right;margin-right: 10px;">
          <el-button type="danger" @click="fuzhiCopy()">复制活动</el-button>
          <el-button type="danger" @click="handleinfo('', 1)">新增</el-button>
          <!-- <span><b>活动列表地址：</b>/pagesTwo/pages/happyDecoration/renovationPage/renovationPage</span> -->
        </div>
      </div>
      <!-- table 列表 -->
      <div class="table_container">
        <el-table :data="dataList" stripe border @selection-change="handleSelectionChange">
          <el-table-column type="selection" align="center"/>
          <el-table-column label="序号" align="center" width="50">
            <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
          </el-table-column>
          <el-table-column label="活动ID" align="center" width="160">
            <template scope="scope">
              <span :title="scope.row.flexibleCode">{{scope.row.flexibleCode}}</span>
            </template>
          </el-table-column>
          <el-table-column label="商品名称" align="center">
            <template scope="scope">
              <span class="spanList" :title="scope.row.goodsName">{{scope.row.goodsName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="商品价格(元)" align="center">
            <template scope="scope">{{scope.row.goodsPrice}}</template>
          </el-table-column>
          <el-table-column label="中奖名额" align="center">
            <template scope="scope">{{scope.row.personWinningNum}}</template>
          </el-table-column>
          <el-table-column label="活动时间" align="center" width="180">
            <template scope="scope">{{scope.row.eventDateStart}} - {{scope.row.eventDateEnd}}</template>
          </el-table-column>
          <el-table-column label="开奖时间" align="center">
            <template scope="scope">{{scope.row.eventDateEndTime}}</template>
          </el-table-column>
          <el-table-column label="单人次价格(元)" align="center">
            <template scope="scope">{{scope.row.personPrice}}</template>
          </el-table-column>
          <el-table-column label="已参与人数" align="center">
            <template scope="scope">{{scope.row.personPastNum}}</template>
          </el-table-column>
          <el-table-column label="活动状态" align="center">
            <template scope="scope">{{scope.row.eventStatusMsg}}</template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" align="center" width="250">
            <template scope="scope">

              <span class="handle" @click="endToExamine(scope.row)" v-if="scope.row.eventStatus == 3">
                <i class="el-icon-trophy"/> 开奖
              </span>

              <span class="handle" @click="handleinfo(scope.row, 3)" v-if="scope.row.eventStatus != 1">
                <i class="el-icon-view"></i> 查看
              </span>

              <span class="handle" @click="handleSendaPrize(scope.row)"
                v-if="scope.row.eventStatus == 4 && scope.row.lotteryStatus == true">
                <i class="el-icon-truck"></i> 派奖
              </span>

              <span class="handle" @click="xiaxian(scope.row)"
                v-if="scope.row.eventStatus == 2 || scope.row.eventStatus == 3">
                <i class="el-icon-remove-outline"/> 关闭
              </span>

              <span class="handle" @click="choujiang(scope.row)"
                v-if="scope.row.eventStatus == 3 || scope.row.eventStatus == 4">
                <i class="el-icon-present"/> 抽奖
              </span>

              <template v-if="scope.row.eventStatus == 1">
                <span class="handle" @click="fabu(scope.row)"> <i class="el-icon-circle-check"></i> 开启 </span>
                <span class="handle" @click="handleinfo(scope.row, 2)"> <i class="el-icon-edit-outline"></i> 编辑 </span>
                <span class="handle" @click="deleteMerchant(scope.row)"> <i class="el-icon-delete"></i> 删除 </span>
              </template>
              
            </template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
        :current-page="pageInfo.pageNum" :page-size="10" :total="totalRowsCount" style="float:right;margin:10px 0;"/>
      </div>
    </div>
  </div>
  <!-- 幸运购活动 -->
  <div v-if="isOrderWatch">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="活动信息" name="first"/>
      <el-tab-pane label="参与信息" name="second" v-if="decorationSeeDis"/>
      <el-tab-pane label="推广记录" name="third" v-if="decorationSeeDis"/>
    </el-tabs>
    <!-- 活动信息 -->
    <div class="main_container" v-show="activeName=='first'">
      <!-- 新增/编辑幸运购活动 -->
      <p class="model_top_title">活动基本信息</p>
      <div class="redTishi">
        <!-- <span v-if="decorationSeeDis"><b>活动ID：</b>{{xygid}}</span> -->
        <!-- <span v-if="decorationSeeDis"><b>活动页面链地址：</b>/pagesTwo/pages/happyDecoration/renovationPage/renovationPage?id={{xygid}}</span> -->
        <span>本页面内容除，视频为选填，其它全部为必填项。</span>
      </div>
      <el-form class="decorationDiaryDiv">
      <el-row>
        <el-col :span="8">
          <el-form-item label="活动时间：" label-width="120px">
            <el-date-picker v-model="groupWork.huodongTime" type="daterange" align="right"
              value-format="yyyy-MM-dd" @change="hdsjTime" :disabled="decorationSeeDis"
              start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
              style="width:66%;cursor:pointer;background:#fff;border:1px solid #eee;"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="开奖时间：" label-width="120px">
            <el-time-select v-model="groupWork.kjTime" placeholder="选择时分" style="width: 66%"
            :picker-options="{start: '07:00', step: '00:15', end: '24:00'}" :disabled="decorationSeeDis"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="直播间号码：" label-width="120px">
            <el-input v-model="groupWork.diaryName" placeholder="例：12345678" style="width:66%"
            maxlength="20" :disabled="decorationSeeDis"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="商品名称：" label-width="120px">
            <el-input v-model="groupWork.spmc" placeholder="例如：欧派橱柜XXXX型号" maxlength="20"
            style="width:66%" :disabled="decorationSeeDis"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="商品价格：" label-width="120px">
            <el-input v-model="groupWork.commodityPrice" placeholder="例：5888.88元"
              maxlength="7" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
              style="width:66%" :disabled="decorationSeeDis"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="商品描述：" label-width="120px">
            <el-input v-model="groupWork.productDescription" placeholder="例如：品质橱柜-健康生活360" maxlength="20"
            style="width:66%" :disabled="decorationSeeDis"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="分享标题：" label-width="120px">
            <el-input v-model="groupWork.decorationPeriod" placeholder="大家一起来帮我装修吧~" maxlength="50"
              style="width:66%" :disabled="decorationSeeDis"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="参与价格：" label-width="120px" v-show="groupWork.houseType == 1">
            <el-input v-model="groupWork.housingArea" placeholder="请输入" maxlength="8"
              onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
              style="width:66%" :disabled="decorationSeeDis"/>
            <span style="margin-left: 10px;">元</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="活动主图：" label-width="120px">
            <div class="uploadActive">
              <el-upload class="avatar-uploader activeUploadImg" action :disabled="decorationSeeDis"
                :before-upload="(file)=>beforUploadThree(file, 1)">
                <div class="fxfmImgUrl" v-if="groupWork.zbjbjUrl">
                  <el-image :src="groupWork.zbjbjUrl" fit="cover" style="width: 80px; height: 80px"/>
                </div>
                <div v-if="!groupWork.zbjbjUrl" class="fxfmImgUrl">
                  <i class="el-icon-plus upBtn"></i>
                </div>
              </el-upload>
            </div>
            <div style="color:#888;">尺寸：1200*675，支持的图片格式：jpg、png。</div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="分享封面：" label-width="120px">
            <div class="uploadActive">
              <el-upload class="avatar-uploader activeUploadImg" action :disabled="decorationSeeDis"
                :before-upload="(file)=>beforUploadThree(file, 2)">
                <div class="fxfmImgUrl" v-if="groupWork.fxtpUrl">
                  <el-image :src="groupWork.fxtpUrl" fit="cover" style="width: 80px; height: 80px"/>
                </div>
                <div v-if="!groupWork.fxtpUrl" class="fxfmImgUrl">
                  <i class="el-icon-plus upBtn"></i>
                </div>
              </el-upload>
            </div>
            <div style="color:#888;">尺寸：1000*800，支持的图片格式：jpg、png。</div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="视频（选填）：" label-width="120px">
            <div v-if="videoSrc" class="videoClass">
              <span @click="newSeevideo(videoSrc)" class="previewingVideo">
                <img :src="videoImg" v-if="videoImg">
                <img src="../../assets/img/spfm.png" v-else>
                <div class="iconcontainer"><img src="../../assets/img/play.png" class="playIcon"/></div>
              </span>
              <img src="../../assets/img/aicon36.png" @click="delvideo()" v-if="videoSrc" class="chahao"/>
            </div>
            <el-upload v-else class="avatar-uploader activeUploadImg" action="" accept="video/*" :before-upload="handleFile">
              <el-progress type="circle" v-if="videoFlag" :percentage="videoUploadPercent" :width="80" :height="80"/>
              <i v-else class="el-icon-plus avatar-uploader-icon"/>
            </el-upload>
            <div style="color:#888;">视频格式仅支持: mp4. 视频大小不能超过 50MB !</div>
          </el-form-item>
        </el-col>
        <canvas id="canvasa" hidden/>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="商品图片：" label-width="120px">
            <div class="upPictures">
              <div class="multigraph" v-for="(item,index) in detailImgUrlarr" :key="index" :data-img="item">
                <el-image :src="item.picUrl" style="width: 80px; height:80px" @click="handleClickItem" :preview-src-list="[item.picUrl]"/>
                <div class="chahao" @click.stop="deldetail(index)" v-if="!decorationSeeDis">
                  <img src="../../assets/img/aicon36.png"/>
                </div>
              </div>
              <el-upload action multiple v-if="flag < 5" :before-upload="beforeAvatarUpload" accept=".png, .jpg,.jpeg">
                <i class="el-icon-plus upBtn" v-if="!decorationSeeDis"></i>
              </el-upload>
              <div style="color:#888;clear: both;">尺寸：1200*1200，支持的图片格式：jpg、png。</div>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <!-- <el-form-item label="商品图片：" label-width="120px">
            <div class="uploadActive">
              <el-upload class="avatar-uploader activeUploadImg" action :before-upload="(file)=>beforUploadThree(file, 3)">
                <div class="fxfmImgUrl" v-if="groupWork.sltpUrl">
                  <img :src="groupWork.sltpUrl" style="width: 160px; height: 80px"/>
                </div>
                <div v-if="!groupWork.sltpUrl" class="fxfmImgUrl">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </div>
              </el-upload>
            </div>
            <div style="color:#888;line-height: 10px;">尺寸：1200*1200，支持的图片格式：jpg、png。</div>
          </el-form-item> -->
        </el-col>
        <el-col :span="8">
          <!-- <el-form-item label="活动主图 :" label-width="120px">
            <div class="uploadActive">
              <el-upload class="avatar-uploader activeUploadImg" action :before-upload="(file)=>beforUploadThree(file, 4)">
                <div class="fxfmImgUrl" v-if="groupWork.hdztUrl">
                  <img :src="groupWork.hdztUrl" style="width: 160px; height: 80px"/>
                </div>
                <div v-if="!groupWork.hdztUrl" class="fxfmImgUrl">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </div>
              </el-upload>
            </div>
            <div style="color:#888;line-height: 10px;">建议尺寸：1200*675，支持的图片格式：jpg、png。</div>
          </el-form-item> -->
        </el-col>
      </el-row>
      <!-- <el-row>
        <el-col :span="8">
          <el-form-item label="商品品类 :" label-width="120px">
            <el-select v-model="groupWork.communityName" filterable placeholder="请选择"
            style="width:66%" :disabled="decorationSeeDis" @change="handleCommodityType">
              <el-option v-for="(item,index) in communityArr" :key="index" :label="item.Name" :value="item.Id"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="活动类型 :" label-width="120px">
            <el-select v-model="groupWork.houseType" filterable placeholder="请选择"
            style="width:66%" :disabled="decorationSeeDis" @change="handleActivityType">
              <el-option v-for="(item,index) in houseTypeArr" :key="index" :label="item.Name" :value="item.Id"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="活动城市 :" label-width="120px">
            <el-cascader placeholder="请选择城市" style="width:80%" v-model="groupWork.chengshi" ref="cityAll"
            :options="optionsCity" filterable clearable @change="handleChange" :disabled="decorationSeeDis"/>
          </el-form-item>
        </el-col>
      </el-row> -->
      </el-form>

      <!-- 活动形式配置 -->
      <p class="model_top_title">活动形式配置</p>
      <el-form class="decorationDiaryDiv">
        <el-row>
          <el-col :span="8" style="margin: 0 0 10px 10px;">
            <el-radio v-model="xingshi" :label="1" :disabled="decorationSeeDis">形式一（不限制参与人数）</el-radio>
          </el-col>
          <el-col :span="8" style="margin: 0 0 10px 6px;">
            <el-radio v-model="xingshi" :label="2" :disabled="decorationSeeDis">形式二（固定参与人数和奖品数量）</el-radio>
          </el-col>
          <el-col :span="8">
            
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="参与人数每满：" label-width="120px">
              <el-input v-model="groupWork.cyrsmm" placeholder="请输入" maxlength="20"
                style="width: 35%" :disabled="decorationSeeDis || xingshi==2"/> 人奖品增加一份
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="可参与人数：" label-width="120px">
              <el-input v-model="groupWork.partake" placeholder="设定可参与人数" maxlength="20"
              style="width:66%" :disabled="decorationSeeDis || xingshi==1"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="中奖名额：" label-width="120px">
              <el-input v-model="groupWork.zjrs" placeholder="请输入" maxlength="20"
              style="width:66%" :disabled="decorationSeeDis || xingshi==1"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      
      <!-- 领奖信息 -->
      <p class="model_top_title">领奖信息</p>
      <el-form class="decorationDiaryDiv">
      <el-row>
        <el-col :span="8">
          <el-form-item label="店铺名称：" label-width="120px">
            <el-input v-model="groupWork.shopName" placeholder="请输入" maxlength="20"
              style="width: 66%" :disabled="decorationSeeDis"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="店铺地址：" label-width="120px">
            <el-input v-model="groupWork.shopAddress" placeholder="请输入" maxlength="50"
            style="width:66%" :disabled="decorationSeeDis"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="电话号码：" label-width="120px">
            <el-input v-model="groupWork.telephoneNumber" placeholder="例：13812345678"
              maxlength="11" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
                style="width: 66%" :disabled="decorationSeeDis"/>
          </el-form-item>
        </el-col>
      </el-row>
      </el-form>
      <p class="model_top_title">商品详情</p>
      <wjEditor :desc="productProfile" @change="contentChangeOne" style="width: 97%;margin: 0 auto;"/>
      <p class="model_top_title">活动规则</p>
      <wjEditor :desc="activityDesc" @change="contentChangeTwo" style="width: 97%;margin: 0 auto;"/>

      <p class="boldTitle">付费推广
        <span style="font-weight: normal; font-size: 12px; color:#999;">（活动结束后未使用的推广费用，5个工作日内将自动退款到原微信支付账户。）</span>
      </p>
      <span class="boldTitle">创客分享奖现金：</span>
      <el-button type="danger" @click="addAndPreservation(2)" v-show="!decorationSeeDis">配置</el-button>
      <template v-if="seejlfsTwo !=''">
        <span class="threePrice">单份奖励：{{rewardTwo}}元</span>
        <span class="threePrice">奖励份数：{{seejlfsTwo}}份</span>
        <!-- <span class="threePrice">需充值金额：{{Math.ceil(recharge.totalprice*100)/100}} 元（微信收取{{wxrate*1000}}‰手续费）</span> -->
        <span class="threePrice">需充值金额：{{Math.ceil(recharge.totalprice*100)/100}} 元</span>
      </template>
      <template v-else>
        <span class="threePrice">无配置</span>
      </template>
      <el-button type="primary" @click="chongzhiPz" v-show="!decorationSeeDis && seejlfsTwo !=''" style="margin-left: 10px;">重置</el-button>
      
      <!-- 弹框按钮 -->
      <div style="width: 100%;text-align: center;margin: 10px 0;display: inline-block;">
        <el-button type="button" @click="showOrder()">{{ decorationSeeDis?'返回':'取消' }}</el-button>
        <el-button type="danger" @click="addAndPreservation(1)" v-if="!decorationSeeDis">保存</el-button>
      </div>
    </div>
    <!-- 参与信息 -->
    <div class="main_container" v-show="activeName=='second'">
      <!-- 参与信息 -->
      <div class="table_container">
        <div class="canyuxinxi">
          <span>需要参与人数：<b>{{participationInStatistics.person_max_num}}  人</b></span>
          <span>实际参与人数：<b>{{participationInStatistics.personPastNum}}  人</b></span>
          <span>兑换优惠券：<b>{{participationInStatistics.personPast4Num}} 人</b></span>
          <span>退款：<b>{{participationInStatistics.personPast3Num}} 人</b></span>
          <span>待处理：<b>{{participationInStatistics.personPastOtherNum}} 人</b></span>
          <el-button type="danger" @click="onExport()">导出</el-button>
        </div>
        <div class="table_inner_container" style="height:auto">
          <el-table :data="participationInformationList" class="invoice_tab" stripe border style="height:auto;max-height:500px">
            <el-table-column label="序号" align="center" width="50" key="1">
              <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
            </el-table-column>
            <el-table-column label="邀请员工昵称" align="center">
              <template scope="scope">{{scope.row.individualUserName}}</template>
            </el-table-column>
            <el-table-column label="邀请员工手机号" align="center">
              <template scope="scope">{{scope.row.individualUserPhone}}</template>
            </el-table-column>
            <el-table-column label="用户手机号" align="center">
              <template scope="scope">{{scope.row.userTel}}</template>
            </el-table-column>
            <el-table-column label="开奖号码" align="center">
              <template scope="scope">{{scope.row.pastNumber}}</template>
            </el-table-column>
            <el-table-column label="参与时间" align="center">
              <template scope="scope">{{scope.row.createTime}}</template>
            </el-table-column>
            <el-table-column label="是否中奖" align="center">
              <template scope="scope">{{scope.row.prizes==''||scope.row.prizes==null||scope.row.prizes=='-'?'否':'是'}}</template>
            </el-table-column>
            <el-table-column label="奖品名称" align="center">
              <template scope="scope">
                <span class="spanList" :title="scope.row.prizes">{{ scope.row.prizes }}</span>
              </template>
            </el-table-column>
            <el-table-column label="状态" align="center">
              <template scope="scope">{{scope.row.pastStatusMsg}}</template>
            </el-table-column>
          </el-table>
        </div>
        <!--分页-->
        <el-pagination layout="prev, pager, next" @current-change="handleCanyuXinxi"
        :current-page="pageIndex" :page-size="10" :total="canyuTotalCount" style="margin-top: 10px;float:right"/>
      </div>
      <!-- 底部操作按钮 -->
      <div style="width: 100%;text-align: center;margin-bottom: 10px;display: inline-block;">
        <el-button type="button" @click="showOrder()">返回</el-button>
      </div>
    </div>
    <!-- 推广记录 -->
    <div class="main_container" v-show="activeName=='third'">
      <div class="reminder" style="margin: 15px;">
        分享奖励：每份 <b>{{tgdetails.univalence}}</b> 元，　
        共 <b>{{tgdetails.totalcount}}</b> 份　
        已领取 <b class="redClass">{{tgdetails.consumecount}}</b> 份　
        剩余 <b class="redClass">{{tgdetails.remaincount}}</b> 份　
        余额 <b class="redClass">{{tgdetails.remainprice}}</b> 元　
        退款金额：<b>{{tgdetails.refundprice}}</b> 元
      </div>
      <!-- table 列表 -->
      <div class="table_container">
        <el-table :data="tkjlList" class="invoice_tab tabler_inner_container" stripe border style="height:auto;max-height:500px">
          <el-table-column label="序号" align="center" width="50">
            <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
          </el-table-column>
          <el-table-column label="领取时间" align="center">
            <template scope="scope">{{scope.row.createtime}}</template>
          </el-table-column>
          <el-table-column label="分享者手机号" align="center">
            <template scope="scope">{{scope.row.phone}}</template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination layout="prev, pager, next" @current-change="ckfxfenye"
      :current-page="pageCkfxindex" :page-size="10" :total="ckfxCount" style="float:right;margin: 10px 10px 0 0;"/>
      <!-- 底部操作按钮 -->
      <div style="width: 100%;text-align: center;margin-bottom: 10px;display: inline-block;">
        <el-button type="button" @click="showOrder()">返回</el-button>
      </div>
    </div>
  </div>
  <!-- 复制活动-弹框 -->
  <el-dialog title="复制活动" :visible.sync="isToCopy" width="44%" center>
    <el-form class="formItem">
      <el-form-item label="原活动时间 :" style="width:35%;" label-width="88px">
        <span style="color: #999">{{originalActivityTimeStart}} - {{originalActivityTimeEnd}}</span>
      </el-form-item>
      <el-form-item label="开奖时间 :" style="width:50%;" label-width="88px">
        <span style="color: #999">{{openingTime}}</span>
      </el-form-item>
    </el-form>
    <el-form class="formItem">
      <el-form-item label="新活动时间 :" style="width:35%;" label-width="88px">
        <el-date-picker v-model="value1" type="daterange" align="right"
          value-format="yyyy-MM-dd HH:mm:ss" @change="changeActiveTime"
          start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
          style="width:100%;cursor:pointer;background:#fff;border:1px solid #eee;"/>
      </el-form-item>
      <el-form-item label="开奖时间 :" style="width:50%;" label-width="88px">
        <el-time-select v-model="spikeTime" placeholder="选择时间"
          :picker-options="{ start: '07:00', step: '00:15', end: '24:00' }"/>
      </el-form-item>
    </el-form>
    <!-- 弹框按钮 -->
    <div style="text-align:center">
      <el-button type="button" @click="isToCopy = false">取消</el-button>
      <el-button type="danger" @click="editSubmit()">保存</el-button>
    </div>
  </el-dialog>
  <!-- 开奖管理-弹框 -->
  <el-dialog title="开奖管理" :visible.sync="isToComment" width="30%" center>
    <!-- <div class="lotteryStyle" v-for="(item, index) in activeOrderList" :key="index">
      <el-form class="infoCheckStyle">
        <el-form-item label="中奖者：" style="display:flex;width:73%;">
          <el-input v-model="item.publisherPhone" placeholder="请输入中奖号码"
            :disabled="item.zhongjiang || noLottery"/>
        </el-form-item>
        <el-form-item>
          <el-button type="danger" @click="finddes(item.publisherPhone, index)" :disabled="item.zhongjiang || noLottery">查 询</el-button>
        </el-form-item>
      </el-form>
      <ul class="classWinnerStyle" v-if="JSON.stringify(item.personalInfo) != '{}'">
        <li><img :src="item.personalInfo.headSculpturePicUrl" style="width:36px;"></li>
        <li class="kjmc" :title="item.personalInfo.userName">{{item.personalInfo.userName}}</li>
        <li><b>手机号: </b> {{item.personalInfo.userTel}}</li>
        <li class="dizhi" :title="item.personalInfo.userCity">{{item.personalInfo.userProvince}} - {{item.personalInfo.userCity}}</li>
        <el-checkbox v-model="item.zhongjiang" :disabled="noLottery" style="float: right;">确定中奖者</el-checkbox>
      </ul>
    </div> -->
    <div style="margin-top:10px">
      <!-- <el-checkbox v-model="noLottery">本次活动未达到需要人次，不予开奖</el-checkbox> -->
      <el-radio v-model="kjradio" :label="1" style="display: block;margin-bottom: 15px;">正常开奖</el-radio>
      <el-radio v-model="kjradio" :label="2">本次活动人数未达标，不予开奖</el-radio>
      <p class="zyts">重要提示：请谨慎操作，确定开奖后不可修改</p>
    </div>
    <!-- 弹框按钮 -->
    <div style="text-align:center;margin-top:20px">
      <el-button type="button" @click="isToComment = false">取消</el-button>
      <el-button type="danger" @click="endDrawaPrize()">确定</el-button>
    </div>
  </el-dialog>
  <!-- 派奖管理-弹框 -->
  <el-dialog title="派奖管理" :visible.sync="isToExamine" width="40%" center>
    <div class="formItem" v-for="(item, index) in paijiangList" :key="index">
      <ul class="classPrize">
        <!-- <li><img :src="item.headSculpturePicUrl" style="width:36px;"></li>
        <li class="kjmc" :title="item.userName">{{item.userName}}</li>
        <li><b>手机号: </b> {{item.userTel}}</li>
        <li class="dizhi" :title="item.userCity">{{item.userProvince}} - {{item.userCity}}</li> -->
        <li><b>开奖号码: </b> {{item.pastNumber}}</li>
        <li><b>奖品: </b> <div class="textexceeds" :title="item.prizes">{{item.prizes}}</div></li>
        <el-checkbox v-model="item.pastStatus" style="float: right;">已派奖</el-checkbox>
      </ul>
    </div>
    <!-- 弹框按钮 -->
    <div style="text-align:center;margin-top:10px">
      <el-button type="button" @click="isToExamine = false">取消</el-button>
      <el-button type="danger" @click="endSendaPrize()">确定</el-button>
    </div>
  </el-dialog>
  <!-- 创客分享奖现金 -->
  <el-dialog title="创客分享奖现金" :visible.sync="prizeCash" :center="true" width="50%">
    <el-form style="display:flex;">
      <!-- <el-form-item label="单份奖励：" style="display:flex;margin-bottom:0;margin-right: 30px;">
        <span>{{rewardTwo}}元</span>
      </el-form-item> -->
      <el-form-item label="单份奖励：" style="display:flex;margin-bottom:0;">
        <el-input v-model="rewardTwo" placeholder="请输入" style="width:80%"
        onkeyup="this.value=this.value.replace(/\D|^0/g,'')">
        <i slot="suffix" style="margin-right: 10px;">元</i>
        </el-input>
      </el-form-item>
      <el-form-item label="奖励份数：" style="display:flex;margin-bottom:0;">
        <el-input v-model="recharge.totalcount" placeholder="请输入奖励份数" maxlength="7" style="width:80%"/>
      </el-form-item>
      <el-form-item label="充值金额：" style="display:flex;margin-bottom:0;">
        <!-- <span><b style="color: #F56C6C;">{{Math.ceil(recharge.totalprice*100)/100}}</b> 元（含微信收取{{wxrate*1000}}‰手续费）</span> -->
        <span><b style="color: #F56C6C;">{{Math.ceil(recharge.totalprice*100)/100}}</b> 元</span>
      </el-form-item>
    </el-form>
    <el-form>
      <el-form-item label="分享规则：" style="margin-bottom: 5px;">
        <el-radio-group v-model="fxdpyq">
          <el-radio v-for="item in tasktyps" :key="item.bttid" :label="item.bttid" style="margin-right: 15px;">{{item.tasktypename}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="分享文案：" style="display:flex;margin-bottom:0;">
        <el-input type="textarea" v-model="recharge.remark" :rows="2" placeholder="请输入分享文案内容" maxlength="100" show-word-limit/>
      </el-form-item>
      <el-form-item label="分享要求：" style="margin-bottom: 10px;">
        <!-- <div v-if="tasktyps.length>0">
          <div v-if="get_description('pyq').length > 0" style="margin-bottom: -5px;">【朋友圈】</div>
          <div v-for="(item,index) in get_description('pyq')" :key="index">
            <div style="color: #999;line-height: 25px;">{{index+1}}.{{item}}</div>
          </div>
          <div v-if="get_description('wxq').length > 0" style="margin-bottom: -5px;">【微信群】</div>
          <div v-for="(item,index) in get_description('wxq')" :key="index">
            <div style="color: #999;line-height: 25px;">{{index+1}}.{{item}}</div>
          </div>
        </div> -->
        <div v-if="tasktyps.length>0" style="display: inline-block;">
          <ul v-for="(desc, index) in tasktyps.find(t => t.bttid == fxdpyq).descriptions" :key="index">
            <li v-if="desc.taskdesc.startsWith('【朋友圈】') || desc.taskdesc.startsWith('【微信群】')" style="font-weight: bold;">
              {{ desc.taskdesc }}
            </li>
            <li v-else style="color: #999;line-height: 30px;">
              {{ desc.taskdesc }}
            </li>
          </ul>
        </div>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 20px;">创客范围：<span>【本功用于配置哪些创客来进行推广】</span></div>
    <span style="float: left;">按从事行业：</span>
    <div style="width: 800px;">
      <el-checkbox-group v-model="formmenuOne" @change="handleCheckedCities" style="margin-bottom: 20px;">
        <el-checkbox v-for="item in industry" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
      </el-checkbox-group>
    </div>
    <div style="height: 200px;display: flex;" v-show="formmenuOne.find(i=>i==2)">
      <span style="float: left;">按建材品类：</span>
      <div style="overflow-y: scroll;display: grid;padding: 0 10px 0 0;">
        <el-checkbox v-model="checkAlltwo" :indeterminate="isIndeterminateTwo" @change="handleCheckAllChange(checkAlltwo,2)">
          全部
        </el-checkbox>
        <el-tree ref="tree" show-checkbox :data="category" node-key="id" style="margin-top: 5px;"
        highlight-current :props="defaultProps" class="cktree" :default-checked-keys="formmenuTwo"/>
      </div>
    </div>
    <!-- <div style="width: 500px;background: #F2F2F2;padding: 10px 0;">
      <el-row style="display: flex;justify-content: space-between;padding-bottom: 10px;">
        <el-col :span="11"><b>按行业选择</b></el-col>
        <el-col :span="11"><b>按品类选择</b></el-col>
      </el-row>
      <el-row style="height: 200px;display: flex;justify-content: space-between;">
        <el-col :span="11" style="overflow-y: scroll;display: grid;background: #fff;padding: 10px 0 0 24px;">
          <el-checkbox v-model="checkAllone" :indeterminate="isIndeterminateOne" @change="handleCheckAllChange(checkAllone,1)">
            全部
          </el-checkbox>
          <el-checkbox-group v-model="formmenuOne" @change="handleCheckedCities" style="margin-top: -10px;">
            <el-checkbox v-for="item in industry" :label="item.id" :key="item.id" style="line-height: 30px;">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </el-col>
        <el-col :span="11" style="overflow-y: scroll;display: grid;background: #fff;padding: 10px 0 0 24px;">
          <el-checkbox v-model="checkAlltwo" :indeterminate="isIndeterminateTwo" @change="handleCheckAllChange(checkAlltwo,2)"> 全部 </el-checkbox>
          <el-tree ref="tree" show-checkbox :data="category" node-key="id" style="margin-top: 5px;"
          highlight-current :props="defaultProps" class="cktree" :default-checked-keys="formmenuTwo"/>
        </el-col>
      </el-row>
    </div> -->
    <b style="display: block;margin: 10px 0 5px 0;">付费推广目的：</b>
    <ul>
      <li style="line-height: 32px;" v-for="(item, index) in ckfxjxj" :key="index">{{item.name}}</li>
      <li style="margin-top: 5px;">4.示例截图</li>
      <ul class="videoandpic" v-if="tasktyps.length>0">
        <!--  @click="handleplay(item)" -->
        <li v-for="(item, index) in tasktyps.find(i=>i.bttid==fxdpyq).examples" :key="index">
          <!-- <el-image :src="baseOssUrl+item.videoimg" style="width: 100px; height: 100px"/> -->
          <i class="el-icon-video-play mengceng" v-show="item.mediatype == 2"/>
          <el-image :src="baseOssUrl+item.mediapath" fit="cover" style="width: 100px; height: 100px"
          @click="handleClickItem" :preview-src-list="[baseOssUrl+item.mediapath]"/>
        </li>
      </ul>
    </ul>
    <div style="padding-top:10px;text-align:center">
      <el-button @click="prizeCash = false">取 消</el-button>
      <el-button type="danger" @click="handleJxj()">确定</el-button>
    </div>
  </el-dialog>
  <!-- 播放视频 -->
  <el-dialog title='视频播放' :visible.sync="videoVisible" @close="closeVideo" width="30%" center>
    <video-player ref="videoPlayer" class="video-player vjs-custom-skin" :playsinline="true" :options="playerOptions"/>
  </el-dialog>
  <!-- 微信扫码支付 -->
  <el-dialog title="请使用微信扫码支付" :visible.sync="wxsmzfVisible" width="20%" center @close="closeWxsmzf()">
    <div class="wxsmzfClass">
      <P>{{wxsmzfJine}} 元</P>
      <img :src="wxSmzfImg"/>
    </div>
  </el-dialog>
  <!-- vueCropper 剪裁图片实现-->
  <el-dialog title="图片剪裁" :visible.sync="cropping" append-to-body center>
    <div class="cropper-content">
      <div class="cropper">
        <vueCropper ref="cropper" :img="option.img" :outputSize="option.size" :fixedBox="option.fixedBox"
        :outputType="option.outputType" :full="option.full" :canMove="option.canMove" :infoTrue="option.infoTrue"
        :canMoveBox="option.canMoveBox" :original="option.original" :autoCrop="option.autoCrop" :info="true"
        :fixed="option.fixed" :fixedNumber="option.fixedNumber" :centerBox="option.centerBox"
        :autoCropWidth="option.autoCropWidth" :autoCropHeight="option.autoCropHeight"/>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cropping = false">取 消</el-button>
      <el-button type="primary" @click="finish">确认</el-button>
    </div>
  </el-dialog>
  
  <!-- 确认提示 -->
  <el-dialog title='确认提示' :visible.sync="fufeidialog" width="25%" center>
    <div style="text-align:center;">
      <p style="margin: 10px 0 20px 0; font-size: 16px;">确定要支付推广费用后开启活动吗?</p>
      <b style="font-size: 18px;">-{{zysj}} 元</b>
    </div>
    <div style="text-align:center;margin-top: 20px;">
      <el-button @click="fufeidialog = false">取消</el-button>
      <el-button type="danger" @click="qdfufeu()">确定</el-button>
    </div>
  </el-dialog>
  
  <!-- 充值提示 -->
  <el-dialog title='充值提示' :visible.sync="chongzhidialog" width="25%" center>
    <div style="text-align:center;">
      <p style="margin: 10px 0 30px 0; font-size: 16px;">{{chognzhitishi}}</p>
    </div>
    <div style="text-align:center;">
      <el-button @click="chongzhidialog = false">取消</el-button>
      <el-button type="danger" @click="quchongzhi()">去充值</el-button>
    </div>
  </el-dialog>

  <!-- 初始化弹框 -->
  <el-dialog :center="true" title="请选择店铺" :visible.sync="dialogVisibleadd" width="25%">
    <el-form class="findform">
      <el-form-item label="店铺名称：" style="display:flex;">
        <el-select v-model="filters.shopid" filterable placeholder="请选择店铺" @change="handleChangedptype">
          <el-option v-for="item in options1" :key="item.id" :label="item.name" :value="item.id"/>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="danger" @click="gonext()">确定</el-button>
    </div>
  </el-dialog>

</div>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import wjEditor from '../../components/MyWangEditor'; // 富文本编辑器
import { uploadOSS } from '../../utils/oss'; // oss上传
import { getOssFile, uploadVedio, oneGetProvinceAndCityList, userIdentity, getfilterlist, SelectBrandTypeBaseDataByCondition, payment } from '../../api/newOss';
import { postGetOyGoodsList, postSaveOyGoods, seeGetOyGoods, modifyEditOyGoods, deleteDelOyGoods,
 releasePublishOyGoods, offlinePublishOyGoods, copyOyGoods, getGoodsPastInfo, drawLottery, getWinner, postSendPrize,
 getOyGoodsInfo, getGoodsPastList, getExcel, isrecharge } from "../../api/shopWindow";
import { configtaskType,configSave,delPeizhi,poststatistics } from "../../api/activityFormList";
export default {
  name: 'shoppingActivities',
  mixins: [alertTrends],
  components: { wjEditor },
  data() {
    return {
      baseOssUrl: localStorage.BaseOssUrl,
      show3: true, // 查询区域默认展开
      isOrder: true, // 主页
      isOrderWatch: false, // 详情页
      xygid: "", // 幸运购活动id
      dataList: [], // 查询列表
      groupWorkArr:[], // 复选框选中项
      originalActivityTimeStart: "", // 赋值回显原开始时间
      originalActivityTimeEnd: "", // 赋值回显原开始时间
      openingTime: "", // 开奖时间
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
      },
      totalRowsCount: 0,
      filters: {
        flexibleCode: "", // 活动ID
        goodsName: "", // 商品名称
        strStart: "", // 活动时间
        eventMode: '', // 活动模式
        shopid:'',  // 店铺id
      },
      // 活动时间
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      // 活动模式
      activityModeArr: [
        {
          Id: 1,
          Name: "付费"
        },
        {
          Id: 2,
          Name: "免费"
        },
      ],
      isToCopy: false, // 复制活动 - 弹框
      value1: "", // 新活动时间
      startTime: "", // 开始时间
      endTime: "", // 结束时间
      spikeTime: "", // 开奖时间

      isToComment: false, // 开奖管理 - 弹框
      activeOrderList: [], // 中奖者列表
      noLottery: false, // 不予开奖 - 默认不勾选
      kjradio: 1, // 开奖管理

      isToExamine: false, // 派奖管理 - 弹框
      paijiangList: [],

      activeName: 'first', // 详情页 - tab切换
      decorationSeeDis: false, // 置灰
      groupWork: {
        huodongTime: "", // 活动时间
        ksTime: "", // 开始时间
        jsTime: "", // 结束时间
        kjTime: "", // 开奖时间
        diaryName: "", // 直播间号码
        spmc: "", // 商品名称
        commodityPrice: "", // 商品价格
        productDescription: "", // 商品描述
        decorationPeriod: "", // 分享标题
        housingArea: "", // 参与价格
        
        zbjbjUrl: '', // 活动主图
        zbjshortUrl: '', // 短链接
        fxtpUrl: '', // 分享封面
        fxtpshortUrl: '', // 短链接
        sltpUrl: '', // 商品图片
        sltpshortUrl: '', // 短链接
        
        shopName: "", // 店铺名称
        shopAddress: "", // 店铺地址
        telephoneNumber: "", // 电话号码
        cyrsmm: '', // 参与人数每满
        partake: "", // 可参与人数
        zjrs: "", // 中奖名额

        
        communityName: "", // 商品品类
        houseType: 1, // 活动类型
        chengshi: '', // 活动城市
        hdztUrl: '', // 活动主图-备份
        hdztshortUrl: '', // 短链接
      },
      productProfile: '', // 商品详情
      activityDesc: '', // 活动规则
      xingshi: 1, // 形式类型
      categoryName: "", // 商品品类名称
      // 商品品类
      communityArr: [],
      activityName: "付费", // 活动类型名称
      // 活动类型
      houseTypeArr: [
        {
          Id: 1,
          Name: "付费"
        },
        {
          Id: 2,
          Name: "免费"
        },
      ],
      detailImgUrlarr: [], // 多图集合
      flag: 0,
      participationInStatistics: {},
      participationInformationList: [],
      pageIndex: 1,
      canyuTotalCount: 0,
      
      tgdetails: {},
      tkjlList: [], // 推广记录
      pageCkfxindex: 1, // 页码
      ckfxCount: 0,

      provinceId: 0, // 活动城市 省id
      nameOfProvince: '', // 省名称
      cityId: 0, // 活动城市 市id
      cityName: '', // 市名称
      optionsCity: [
        {
          value: 0,
          label: "全部"
        }
      ],

      videoImg: '', // 视频封面图
      videoSrc: "", // 全连接
      videoShortSrc: "", // 切割之后链接
      videoFlag: false, // 进度条显隐
      videoUploadPercent: 0, // 圆形进度条
      videoVisible: false, // 视频播放
      playerOptions: {
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '4:3', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          src: "" // 视频url地址
        }],
        poster: '', // 你的封面地址
        width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true // 全屏按钮
        }
      },
      dialogVisibleadd: false,
      options1: [],
      
      // 创客分享奖现金
      seejlfsTwo: '',
      rewardTwo: 0, // 单份奖励
      wxrate: 0.006, // 微信手续费
      prizeCash: false, // 创客分享奖现金
      recharge: {
        totalprice: 0,
      },
      fxdpyq: 1, // 分享到朋友圈
      tasktyps: [],
      ckfxjxj: [
        {name: '1.鼓励创客将本活动进行分享，起到宣传活动的作用；'},
        {name: '2.创客按照分享要求进行分享，并按照要求截图上传给商家；'},
        {name: '3.商家对分享的有效性进行辨别审核，审核通过后奖励直接发放给创客。'},
      ],
      
      // 按行业选择
      checkAllone: true,
      isIndeterminateOne: false,
      formmenuOne: [], // 行业已选中
      industry: [], // 行业集合
      // 按品类选择
      checkAlltwo: true,
      isIndeterminateTwo: false,
      formmenuTwo:[], // 品类已选中
      mydata: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      category: [], // 品类集合
      
      timer: null, // 轮询
      lxTime: 0, // 初始开始请求时间
      wxsmzfVisible: false, // 微信扫码支付
      wxsmzfJine: '', // 金额
      wxSmzfImg: '', // 二维码
      brrid: '', // 充值单ID
      cropping: false, // 图片裁剪弹框
      distinguish: '', // 区分两个上传图片
      // 裁剪组件的基础配置option
      option: {
        img: '', // 裁剪图片的地址
        info: false, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: 'jpeg', // 裁剪生成图片的格式
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 1200, // 默认生成截图框宽度
        autoCropHeight: 675, // 默认生成截图框高度
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [1200, 675], // 截图框的宽高比例
        full: false, // 是否输出原图比例的截图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      },
      
      fufeidialog: false, // 确认提示
      zysj: 0, // 金额
      chongzhidialog: false, // 充值提示
      chognzhitishi: '', // 提示文案
      bbtype: '', // 店铺类型

    }
  },
  methods: {
    // 查询列表
    getInit() {
      if(!this.filters.shopid) {
        this.showAlert('请重新打开本功能，并选择一家店铺');
        return false;
      }
      let addParams = {
        pageInfo: this.pageInfo, // 页码 条数
        param: this.filters
      };
      postGetOyGoodsList(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.dataList = data.resultObj.records;
            this.totalRowsCount = data.resultObj.total;
          } else {
            this.dataList = [];
          }
        } else {
          this.dataList = [];
        }
      })
    },
    // 获取描述
    get_description(type){
      let pyq = []
      let wxq = []
      let all = this.tasktyps.find(i=>i.bttid==this.fxdpyq).descriptions.map(i=>{
        if(i.sort/10<1){
          pyq.push(i.taskdesc)
        }else{
          wxq.push(i.taskdesc)
        }
      })
      if (type=='pyq'){
        return pyq
      }else{
        return wxq
      }
    },
    // 开奖
    endToExamine(row) {
      this.xygid = row.flexibleCode;
      this.isToComment = true;
      this.activeOrderList = [];
      let newData = {
        publisherPhone: '', // 中奖者手机号
        personalInfo: {}, // 个人信息
        zhongjiang: false // 确定中奖者
      }
      for (var i = 0; i < row.personWinningNum; i++) {
        // JSON.parse(JSON.stringify())
        this.activeOrderList.push(JSON.parse(JSON.stringify(newData)))
      }
      
    },
    // 查看参与人信息
    finddes(val, index) {
      var addParams = {
        flexibleCode: this.xygid, // 活动ID
        pastNumber: val // 搜索条件值
      };
      getGoodsPastInfo(addParams).then(data => {
        if (data.resultCode == 1) {
          if (data.resultObj) {
            this.activeOrderList[index].personalInfo = data.resultObj
          } else {
            this.activeOrderList[index].personalInfo = {}
          }
        }
      })
    },
    // 确定开奖
    endDrawaPrize() {
      // let zj = this.activeOrderList.filter(item => item.zhongjiang == true)
      // if(zj.length == 0 && this.noLottery == false) {
      //   this.showAlert('至少选中一个中奖者 或 选择不予开奖');
      //   return false;
      // }
      // let obj = zj.map(item => {return {userId: item.personalInfo.userId}});
      // let newBoolean = this.noLottery == true ? false : true;
      let newBoolean = this.kjradio == 1 ? true : false;
      drawLottery('', newBoolean, this.xygid).then(data => {
        if (data.resultCode == 1) {
          this.showAlert('操作成功', 'success');
          this.isToComment = false;
          this.getInit();
        }
      });
    },
    // 派奖
    handleSendaPrize(row) {
      this.xygid = row.flexibleCode;
      this.paijiangList = [];
      this.isToExamine = true;
      // 获取中奖人数据
      var addParams = '';
      getWinner(addParams, this.xygid).then(data => {
        if (data.resultCode == 1) {
          this.paijiangList = data.resultObj;
          this.paijiangList.map(item => item.pastStatus == 5 ? item.pastStatus = true : item.pastStatus = false)
        } else {
          this.paijiangList = []
        }
      })
    },
    // 确定派奖
    endSendaPrize() {
      let pj = this.paijiangList.filter(item => item.pastStatus == true)
      if(pj.length == 0) {
        this.showAlert('至少勾选一项');
        return false;
      }
      var objPj = pj.map(item => {return {userId: item.userId}});
      postSendPrize(objPj, this.xygid).then((data) => {
        if (data.resultCode == 1) {
          this.showAlert('派奖成功', 'success');
          this.isToExamine = false;
          this.getInit();
        }
      });
    },
    // 显示主页
    showOrder() {
      this.isOrder = true; // 主页
      this.isOrderWatch = false; // 详情页
    },
    // 新增 & 编辑 & 查看
    handleinfo(row, type) {
      this.activeName = 'first';
      if (type==1&&!this.filters.shopid) {
        this.showAlert('请重新打开本功能，并选择一家店铺');
        return false;
      }
      this.isOrder = false; // 主页
      this.isOrderWatch = true; // 详情页
      if(type==1){
        this.xygid = "";
        this.decorationSeeDis = false // 置灰
        this.groupWork = {
          huodongTime: "", // 活动时间
          ksTime: "", // 开始时间
          jsTime: "", // 结束时间
          kjTime: "", // 开奖时间
          diaryName: "", // 直播间号码
          spmc: "", // 商品名称
          commodityPrice: '', // 商品价格
          productDescription: "", // 商品描述
          decorationPeriod: "", // 分享标题
          housingArea: "", // 参与价格

          zbjbjUrl: '', // 活动主图
          fxtpUrl: '', // 分享封面
          sltpUrl: '', // 商品图片

          shopName: "", // 店铺名称
          shopAddress: "", // 店铺地址
          telephoneNumber: "", // 电话号码
          cyrsmm: '', // 参与人数每满
          partake: "", // 可参与人数
          zjrs: "", // 中奖名额
          

          communityName: "", // 商品品类
          houseType: 1, // 活动类型
          chengshi: '', // 活动城市
          hdztUrl: '', // 活动主图-备份
        }
        this.videoSrc = '';
        this.videoShortSrc = '';
        this.productProfile = ''; // 商品详情
        this.activityDesc = ''; // 活动规则
        this.activityName = '付费';
        this.detailImgUrlarr = [];
        this.seejlfsTwo = ''; // 清空已配置
      }else if(type==2){
        this.xygid = row.flexibleCode;
        this.decorationSeeDis = false; // 置灰
        this.detailImgUrlarr = [];
        // 调用回显接口
        this.seeEcho();
        this.getPeizhi(); // 获取配置详情
      }else{
        this.xygid = row.flexibleCode;
        this.decorationSeeDis = true // 置灰
        // 调用回显接口
        this.seeEcho();
        this.getPeizhi(); // 获取配置详情
        this.handleHeadStatistics(); // 调用查询头部统计
        this.getyushoulist(); // 查看活动-列表
      }
    },
    // 配置 & 保存
    addAndPreservation(type) {
      if(this.groupWork.huodongTime == ''){
        this.showAlert('请选择活动时间');
        return false;
      }
      if(this.groupWork.kjTime == ''){
        this.showAlert('请选择开奖时间');
        return false;
      }
      if(this.groupWork.diaryName == ''){
        this.showAlert('请输入直播间号码');
        return false;
      }
      if(this.groupWork.spmc == ''){
        this.showAlert('请输入商品名称');
        return false;
      }
      if(this.groupWork.commodityPrice == ''){
        this.showAlert('请输入商品价格');
        return false;
      }
      if(this.groupWork.productDescription == '') {
        this.showAlert('请输入商品描述');
        return false;
      }
      if(this.groupWork.decorationPeriod == ''){
        this.showAlert('请输入分享标题');
        return false;
      }
      if(this.groupWork.housingArea == ''){
        this.showAlert('请输入大于0的参与价格');
        return false;
      }
      
      if(!this.groupWork.zbjbjUrl) {
        this.showAlert('请上传活动主图');
        return false;
      }
      if(!this.groupWork.fxtpUrl) {
        this.showAlert('请上传分享封面');
        return false;
      }
      if(this.detailImgUrlarr.length == 0){
        this.showAlert('请至少上传一张商品图片');
        return false;
      }
      if(this.groupWork.shopName == ''){
        this.showAlert('请输入店铺名称');
        return false;
      }
      if(this.groupWork.shopAddress == ''){
        this.showAlert('请输入店铺地址');
        return false;
      }
      if(this.groupWork.telephoneNumber == ''){
        this.showAlert('请输入电话号码');
        return false;
      }
      if(this.xingshi==1){
        if(this.groupWork.cyrsmm == ''){
          this.showAlert('请输入参与人数每满');
          return false;
        }
      }else{
        if(this.groupWork.partake == ''){
          this.showAlert('请输入可参与人数');
          return false;
        }
        if(this.groupWork.zjrs == '') {
          this.showAlert('请输入中奖名额');
          return false;
        }
      }
      if(!this.productProfile){
        this.showAlert('请输入商品详情');
        return false;
      }
      if(!this.activityDesc){
        this.showAlert('请输入活动规则');
        return false;
      }
      // if(this.groupWork.communityName == ''){
      //   this.showAlert('请选择商品品类');
      //   return false;
      // }
      // if(this.groupWork.houseType == ''){
      //   this.showAlert('请选择活动类型');
      //   return false;
      // }
      // if(this.groupWork.chengshi == ''){
      //   this.showAlert('请选择活动城市');
      //   return false;
      // }
      // if(!this.groupWork.hdztUrl) {
      //   this.showAlert('请上传活动主图');
      //   return false;
      // }
      // if(!this.groupWork.sltpUrl) {
      //   this.showAlert('请上传商品图片');
      //   return false;
      // }
      var threeimgtxt = [
        {
          "picType": 2,
          "picUrl": this.groupWork.zbjshortUrl, // 活动主图
          "Remark": ""
        },
        {
          "picType": 3,
          "picUrl": this.groupWork.fxtpshortUrl, // 分享封面
          "Remark": ""
        },
        {
          "picType": 0,
          "picUrl": this.videoShortSrc, // 视频-短链接
          "Remark": ""
        }
      ]
      setTimeout(()=>{
      let addParams = {
        // operator: localStorage.Id, // 操作人id
        shopid: this.filters.shopid, // 店铺ID
        flexibleCode: Number(this.xygid), // 幸运购活动id
        eventDateStart: this.groupWork.ksTime, // 活动开始日期
        eventDateEnd: this.groupWork.jsTime, // 活动结束日期
        eventDateEndTime: this.groupWork.kjTime, // 开奖时间
        goodsLiveNum: this.groupWork.diaryName, // 直播间号码
        goodsName: this.groupWork.spmc, // 商品名称
        goodsPrice: this.groupWork.commodityPrice, // 商品价格
        goodsDesc: this.groupWork.productDescription, // 商品描述
        goodsTitle: this.groupWork.decorationPeriod, // 分享标题
        personPrice: this.groupWork.houseType == 1?Number(this.groupWork.housingArea):0, // 参与价格
        
        // 商品图片集合 + 单图 + 视频
        oyGoodsPics: this.detailImgUrlarr.map(item => {
          return {picType:1, picUrl: item.picUrl.replace(localStorage.BaseOssUrl, ''),Remark:''}}).concat(threeimgtxt),

        shopName: this.groupWork.shopName, // 店铺名称
        shopAddress: this.groupWork.shopAddress, // 店铺地址
        shopTel: this.groupWork.telephoneNumber, // 电话号码
        lotterytype: this.xingshi, // 开奖方式 1=不限制参与人数 2=固定参与人数和奖品数量
        personMaxNum: this.xingshi==1?this.groupWork.cyrsmm:this.groupWork.partake, // 参与人数每满 & 可参与人数
        personWinningNum: this.groupWork.zjrs?this.groupWork.zjrs:0, // 中奖名额
        goodsDetails: this.productProfile, // 商品详情
        goodsRule: this.activityDesc, // 活动规则


        // goodsType: this.groupWork.communityName, // 商品品类1：橱柜 2床  3床垫
        // goodsTypeMsg: this.categoryName, // 商品品类名称
        // eventMode: this.groupWork.houseType, // 活动类型
        // eventModeMsg: this.activityName, // 活动模式名称
        // userProvince: this.nameOfProvince, // 省份名称
        // userProvinceCode: this.provinceId, // 省份编码
        // userCity: this.cityName, // 城市名称
        // userCityCode: this.cityId, // 城市编码
        // hdztUrl: this.groupWork.hdztUrl, // 活动主图-备份
      };
      let thisApi = this.xygid?modifyEditOyGoods:postSaveOyGoods;
      thisApi(addParams).then(data => {
        if(data.resultCode == 1) {
          if(type==1){ // 正常保存
            this.showAlert(data.resultMsg, 'success');
            this.isOrder = true; // 主页
            this.isOrderWatch = false; // 详情页
            this.getInit();
          }else{ // 触发配置按钮
            if(this.xygid || data.resultObj>0){
              this.xygid = this.xygid?this.xygid:data.resultObj; // 获取幸运购id
              this.getPeizhi(this.xygid); // 获取配置详情
              this.prizeCash = true;
              this.isIndeterminateOne = false;
              this.isIndeterminateTwo = false;
            }else {
              this.showAlert(data.resultMsg);
            }
          }
        } else {
          this.showAlert(data.resultMsg);
        }
      })
      },300)
    },
    // 调用回显接口
    seeEcho(){
      var obj = "";
      this.detailImgUrlarr = [];
      seeGetOyGoods(obj, this.xygid).then((data) => {
        if (data.resultCode == 1) {
          let decorationEcho = data.resultObj;
          this.groupWork.huodongTime = [decorationEcho.eventDateStart, decorationEcho.eventDateEnd]; // 活动时间
          this.groupWork.ksTime = decorationEcho.eventDateStart, // 活动开始日期
          this.groupWork.jsTime = decorationEcho.eventDateEnd, // 活动结束日期
          this.groupWork.kjTime = decorationEcho.eventDateEndTime; // 开奖时间
          this.groupWork.diaryName = decorationEcho.goodsLiveNum; // 直播间号码
          this.groupWork.spmc = decorationEcho.goodsName; // 商品名称
          this.groupWork.commodityPrice = decorationEcho.goodsPrice; // 商品价格
          this.groupWork.productDescription = decorationEcho.goodsDesc; // 商品描述
          this.groupWork.decorationPeriod = decorationEcho.goodsTitle; // 分享标题
          this.groupWork.housingArea = decorationEcho.personPrice; // 参与价格

          // 商品图片集合+单图+视频
          let oyGoodsPics = decorationEcho.oyGoodsPics.map(item => {
            return {
              picType: item.picType,
              picUrl: item.picType==0?item.picUrl:item.picUrl.replace('', localStorage.BaseOssUrl),
              Remark: item.Remark
            }});
            oyGoodsPics.forEach(item=>{
            if(item.picType==1){ // 1=商品图片
              this.detailImgUrlarr.push(item)
            }else if(item.picType==2){ // 2=活动主图
              this.groupWork.zbjbjUrl = item.picUrl; // 全路径
              this.groupWork.zbjshortUrl = item.picUrl.replace(localStorage.BaseOssUrl, ''); // 短
            }else if(item.picType==3){ // 3=分享封面
              this.groupWork.fxtpUrl = item.picUrl; // 全路径
              this.groupWork.fxtpshortUrl = item.picUrl.replace(localStorage.BaseOssUrl, ''); // 短
            }else if(item.picType==0){ // 0=视频
              this.videoSrc = item.picUrl?item.picUrl.replace('', localStorage.BaseOssUrl):''; // 视频-全路径
              this.videoShortSrc = item.picUrl?item.picUrl.replace(localStorage.BaseOssUrl, ''):''; // 视频-短
            }
          })
          
          this.groupWork.shopName = decorationEcho.shopName; // 店铺名称
          this.groupWork.shopAddress = decorationEcho.shopAddress; // 店铺地址
          this.groupWork.telephoneNumber = decorationEcho.shopTel; // 电话号码
          this.xingshi = decorationEcho.lotterytype; // 形式类型
          this.groupWork.cyrsmm = decorationEcho.personMaxNum; // 参与人数每满
          this.groupWork.partake = decorationEcho.personMaxNum; // 可参与人数
          this.groupWork.zjrs = decorationEcho.personWinningNum; // 中奖名额
          this.productProfile = decorationEcho.goodsDetails; // 商品详情
          this.activityDesc = decorationEcho.goodsRule; // 活动规则


          // this.groupWork.communityName = decorationEcho.goodsType; // 商品品类
          // this.groupWork.houseType = decorationEcho.eventMode; // 活动模式
          // this.categoryName = decorationEcho.goodsTypeMsg; // 商品品类名称
          // this.activityName = decorationEcho.eventModeMsg; // 活动模式名称
          // this.groupWork.chengshi = [decorationEcho.userProvinceCode,decorationEcho.userCityCode]; // 活动城市
          // this.nameOfProvince = decorationEcho.userProvince; // 省名称
          // this.provinceId = decorationEcho.userProvinceCode; // 省id
          // this.cityName = decorationEcho.userCity; // 市名称
          // this.cityId = decorationEcho.userCityCode; // 市id
          // this.groupWork.hdztUrl = localStorage.BaseOssUrl + decorationEcho.hdztUrl; // 活动主图-备份
        }
      });
    },
    // 删除
    deleteMerchant(row) {
      this.$swal({
        type: "warning",
        text: "重要信息，你确定要删除吗？",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then((res) => {
        if (res.value) {
          var obj = '';
          deleteDelOyGoods(obj, row.flexibleCode).then((data) => {
            if (data.resultCode == 1) {
              this.showAlert('删除成功', 'success');
              this.getInit();
            }
          });
        }
      });
    },
    // 开启
    fabu(row) {
      this.brrid = row.brrid; // 充值单ID
      this.flexibleCode = row.flexibleCode; // 活动id
      if(row.brrid>0){
        this.deduction(0); // 调取支付0
      } else {
        this.kaiqi(2);
      }
    },
    // 确定开启
    kaiqi(val){
      this.$swal({
        type: "warning",
        text: "确定要开启吗？",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then((res) => {
        if (res.value) {
          if(val==1){
            this.deduction(1); // 调取支付1
          }else{
            releasePublishOyGoods('', this.flexibleCode).then(data => {
              if (data.resultCode == 1) {
                this.showAlert('开启成功', 'success');
                this.getInit();
              }
            });
          }
        }
      });
    },
    // 确定
    qdfufeu(){
      this.fufeidialog=false;
      this.deduction(1); // 调取支付1
    },
    // 支付接口
    deduction(val){
      var obj = {
        attach: 'oygoodsrechargeorder,' + this.flexibleCode +','+ this.brrid,
        price: 0, // 支付金额 单位：元 （店铺分享赚钱必传）
        operatorid: localStorage.Id, // 操作人
        isconfirm: val, // 是否确认支付 0=否 1=是 （非确认支付只返回支付金额 单位：元）
      };
      payment(obj,3,this.filters.shopid).then(data => {
        if (data.resultCode == 1) {
          this.zysj = data.resultObj; // 返回金额 - 待确认支付：返回待支付金额 单位：元 确认支付：>0表示成功
          if(this.zysj>1){
            this.fufeidialog=true;
          }else if(this.zysj==0){
            this.kaiqi(1);
          }else{
            this.showAlert('开启成功', 'success');
            this.getInit();
          }
        }else if(data.resultCode == 4){
          this.chongzhidialog=true; // 充值提示
          this.chognzhitishi=data.resultObj; // 提示文案
        }else{
          this.showAlert(data.resultMsg);
        }
      });
      // postPlaceOrderNative(obj).then(data => {
      //   if (data.ResultCode == 1) {
      //     this.wxsmzfVisible = true;
      //     this.wxsmzfJine = data.resultObj.price; // 金额（单位0）
      //     this.wxSmzfImg = data.resultObj.qrCode; // resultCode=1时返回base64格式二维码图片
          
      //     this.lxTime = new Date().getTime() // 获取触发轮询时的时间
      //     this.inquireData() // 调用轮询接口,开始进行轮询
          
      //   } else if(data.ResultCode == 4) {
      //     this.showAlert('开启成功', 'success');
      //     this.getInit();
      //   }
      // });
    },
    
    // 去充值
    quchongzhi(){
      this.$router.push({
        path: "/vmacount", // 跳转店铺钱包
        query: { shopid: this.filters.shopid }
      });
    },
    // 二维码弹框-关闭
    closeWxsmzf() {
      this.wxsmzfVisible = false; // 二维码弹窗消失
      clearTimeout(this.timer)
    },
    // 轮询请求
    inquireData () {
      const reload = () => {
        clearTimeout(this.timer) // 清除定时器
        // 超过30分钟则停止轮询
        if (new Date().getTime() - this.lxTime > 5 * 60 * 1000) {
          clearTimeout(this.timer)
          return
        }
        // 3s一次, 轮询中
        this.timer = setTimeout(() => {
          this.inquireData() // 调用轮询
        }, 1000)
      }
      let lxObj = {
        id: this.brrid // 充值单ID
      }
      isrecharge(lxObj).then(res => {
        if (res && res.resultCode === 1) {
          // true=已充值、false = 未充值
          if(res.resultObj) {
            this.wxsmzfVisible = false; // 二维码弹窗消失
            this.showAlert('开启成功', 'success');
            this.getInit();
          } else {
            reload() // 没成功,调用轮询
          }
        } else {
          reload() // 没成功,调用轮询
        }
      }).catch(err => {
        reload() // 请求错误,也继续轮询
      })
    },
    // 下线
    xiaxian(row) {
      this.$swal({
        type: "warning",
        text: "确定要下线吗？",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then((res) => {
        if (res.value) {
          var obj = '';
          offlinePublishOyGoods(obj, row.flexibleCode).then((data) => {
            if (data.resultCode == 1) {
              this.showAlert('下线成功', 'success');
              this.getInit();
            }
          });
        }
      });
    },
    // 复制活动
    fuzhiCopy() {
      if(this.groupWorkArr.length != 1){
        this.showAlert('请选择一条数据');
        return false;
      }
      this.isToCopy = true;
      this.value1 = ""
      this.spikeTime = ""
    },
    // 新活动时间
    changeActiveTime(time) {
      this.startTime = time[0];
      this.endTime = time[1];
    },
    // 保存复制活动
    editSubmit() {
      var obj = {
        eventDateStart: this.startTime, // 开始日期yyyy-MM-dd
        eventDateEnd: this.endTime, // 结束日期yyyy-MM-dd
        eventDateEndTime: this.spikeTime, // 开奖时间HH:mm
      };
      copyOyGoods(obj, this.xygid).then((data) => {
        if (data.resultCode == 1) {
          this.showAlert(data.resultMsg, 'success');
          this.isToCopy = false;
          this.getInit();
        }
      });
    },
    // 其他状态-查看活动-头部统计
    handleHeadStatistics(){
      var addParams = "";
      getOyGoodsInfo(addParams, this.xygid).then(data => {
        if (data.resultCode == 1) {
          this.participationInStatistics = data.resultObj;
        }
      })
    },
    // 其他状态-查看活动-列表
    getyushoulist(){
      var addParams = {
        pageInfo: {pageNum: this.pageIndex, pageSize: 10},
        param: {flexibleCode: this.xygid}, // 活动ID
      };
      getGoodsPastList(addParams).then(data => {
        if (data.resultCode == 1) {
          this.participationInformationList = data.resultObj.records;
          this.canyuTotalCount = data.resultObj.total; // 总行数
        } else {
          this.participationInformationList = [];
        }
      })
    },
    // 参与信息分页
    handleCanyuXinxi(val) {
      this.pageIndex = val;
      this.getyushoulist();
    },
    // 详情页tab切换
    handleClick(val) {
      if(val.name=='second'){
        this.pageIndex = 1;
        this.getyushoulist();
      }
      if(val.name=='third'){
        this.pageCkfxindex = 1;
        this.ckfxjlList();
      }
    },
    // 推广记录
    ckfxjlList() {
      let obj = {
        activityid: this.xygid, // 活动id
        pageindex: this.pageCkfxindex, // 页码
        pagesize: 10, // 条数
      }
      poststatistics(obj).then(data => {
        if(data.resultCode == 1) {
          this.tgdetails = data.resultObj;
          this.tkjlList = data.resultObj.consumedata.list;
          this.ckfxCount = data.resultObj.consumedata.totalcount;
        } else {
          this.tkjlList = [];
        }
      })
    },
    // 推广记录-分页
    ckfxfenye(val) {
      this.pageCkfxindex = val;
      this.ckfxjlList();
    },
    // 详情页 活动时间
    hdsjTime(time) {
      this.groupWork.ksTime = time[0];
      this.groupWork.jsTime = time[1];
    },
    // 获取品类
    getBrandType() {
      var obj = {
        userId: localStorage.Id
      };
      SelectBrandTypeBaseDataByCondition(obj).then(data => {
        if (data.ResultCode == 1) {
          this.communityArr = data.ResultObj;
        }
      });
    },
    // 获取商品品类Name
    handleCommodityType(val){
      this.communityArr.filter((item,index) => {
        if(item.Id == val){
          this.categoryName = item.Name; // 商品品类名称
        }
      })
    },
    // 获取活动类型Name
    handleActivityType(val) {
      this.houseTypeArr.filter((item,index) => {
        if(item.Id == val){
          this.activityName = item.Name; // 活动类型名称
        }
      })
    },
    // 请选择省市
    handleChange(val) {
      this.provinceId = val[0];
      this.cityId = val[1];
      let labels = this.$refs['cityAll'].getCheckedNodes()[0].pathLabels;
      this.nameOfProvince = labels[0]
      this.cityName = labels[1]
      
    },
    //查找省
    getprovince() {
      var loginParams = {
        isOpen: 1,
        userId: localStorage.Id
      };
      oneGetProvinceAndCityList(loginParams).then(data => {
        let that = this;
        let provinceAndCityAndarea = [];
        data.ResultObj.map(item => {
          // 省
          let provinceData = {value:item.Id,label:item.Name,children:[]};
          provinceAndCityAndarea.push(provinceData);
          // 市
          item.CityList.map(city => {
            let cityData = {value:city.Id, label:city.Name};
            provinceData.children.push(cityData);
          })
        });
        that.optionsCity = provinceAndCityAndarea;
      })
    },
    // 导出
    onExport() {
      getExcel('', this.xygid).then(data => {})
    },
    // 重置
    fnReset() {
      this.filters = {
        flexibleCode: "", // 活动ID
        goodsName: "", // 商品名称
        strStart: "", // 活动时间
        eventMode: '', // 活动模式
      }
    },
    // 查询
    onSubmit() {
      this.pageInfo.pageNum = 1;
      this.getInit();
    },
    // 复选框
    handleSelectionChange(val) {
      this.groupWorkArr = [];
      val.forEach(element => {
        this.groupWorkArr.push(element.flexibleCode);
        this.xygid = element.flexibleCode;
        this.originalActivityTimeStart = element.eventDateStart;
        this.originalActivityTimeEnd = element.eventDateEnd;
        this.openingTime = element.eventDateEndTime;
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.pageInfo.pageNum = val;
      this.getInit();
    },
    // 获取 行业 & 品类
    getfilterlist(){
      getfilterlist('').then(data => {
        if (data.resultCode == 1) {
          this.industry = data.resultObj.industry; // 行业集合
          this.category = data.resultObj.category; // 品类集合
        }
      })
    },
    getTreeselect() {
      this.$refs.tree.setCheckedKeys(this.formmenuTwo);  //通过 keys 设置目前勾选的节点，使用此方法必须设置 node-key 属性
      // this.mydata = this.convertTreeData(this.category);//因为下面要判断数组长度，树的结构里包含children，所以要将其展开。
      //与全选关联起来，判断是否全部选中还是部分选中
      let checkedCount = this.formmenuTwo.length;
      this.checkAlltwo = checkedCount === this.category.length;
      this.isIndeterminateTwo = checkedCount > 0 && checkedCount < this.category.length;
    },
    // tree 结构转化成一维数组
    convertTreeData(menuOptions) {
      for (let i = 0; i < menuOptions.length; i++) {
        if (menuOptions[i].children != undefined) {
          const temp = menuOptions[i].children;
          delete menuOptions[i].children;
          menuOptions = menuOptions.concat(temp);
        }
      }
      return menuOptions;
    },
    handleCheckedCities(value) {
      let checkedCount = value.length;
      this.checkAllone = checkedCount === this.industry.length;
      this.isIndeterminateOne = checkedCount > 0 && checkedCount < this.industry.length;
    },
    // 全选 / 全不选
    handleCheckAllChange(val,type) {
      if(type==1){
        // this.checkAllone = val;
        // if (this.checkAllone) {
        //   this.$refs.tree.setCheckedNodes(this.industry);
        // } else {
        //   this.$refs.tree.setCheckedKeys([]);
        // }
        const all = this.industry.map(item => {
          return item.id
        })
        this.formmenuOne = val ? all : [];
        this.isIndeterminateOne = false;
      }
      if(type==2){
        this.checkAlltwo = val;
        if (this.checkAlltwo) {
          this.$refs.tree.setCheckedNodes(this.category);
        } else {
          this.$refs.tree.setCheckedKeys([]);
        }
        this.isIndeterminateTwo = false;
      }
    },
    // 多图上传
    beforeAvatarUpload(file) {
      // 判断图片格式
      const isJPG = file.type === 'image/png' || file.type === 'image/jpg' ||file.type === 'image/jpeg';
      // 判断图片大小
      const isLt2M = file.size / 1024 / 1024 <= 1;
      if (!isJPG) {
        this.showAlert('上传图片只支持jpg、png等格式');
        return;
      }
      if (!isLt2M) {
        this.showAlert('上传图片大小不能超过 1MB');
        return;
      }
      this.flag += 1;
      if (this.flag > 5) {
        this.showAlert('最多传入5张图片');
        return false;
      }
      const isSize = new Promise(function(resolve, reject) {
        let width = 1200;
        let height = 1200;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function() {
          let valid = img.width == width && img.height == height;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      })
      isSize.then(() => {
        var _this = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async function(e) {
          _this.handleOss(16); // oss 直传图片
          var newOssPic = await uploadOSS(file,0);
          _this.detailImgUrlarr.push({picUrl:newOssPic})
          // _this.detailImgUrlarr.push(newOssPic);
        };
      }).catch(() => {
        this.showAlert('上传图片宽高尺寸应为1200*1200');
      });
      
    },
    // 删除上传图片
    deldetail(val) {
      let newdetailImgUrlarr = this.detailImgUrlarr;
      for (var i = 0; i < newdetailImgUrlarr.length; i++) {
        if (val == i) {
          newdetailImgUrlarr.splice(i, 1);
        }
      }
      this.detailImgUrlarr = newdetailImgUrlarr;
      this.flag = this.detailImgUrlarr.length;
    },
    // 视频
    handleFile(file) {
      if (file.size > 50*1024 * 1024) {
        this.showAlert('请上传小于50MB的视频');
        return false;
      }
      if (file.type.indexOf("mp4") == -1) {
        this.showAlert('请上传mp4格式的视频');
        return false;
      }
      // 正在上传视频中，请稍后再试
      this.loadingBut = true;
      this.loadingButText = '上传中...';
      this.videoFlag = true;
      this.videoUploadPercent = 0;
      // this.videoUploadPercent = Math.floor(file.percentage)
      this.timer = setInterval(() => {
        if (this.videoUploadPercent >= 99) {
          clearInterval();
          return;
        }
        this.videoUploadPercent += 1;
      }, 50);
      this.videoSrc = "";
      let obj2 = new FormData();
      obj2.append('file',file);
      //上传视频获取路径
      uploadVedio(obj2,14).then(data=>{
        if(data.resultCode == 1){
          this.videoImg = localStorage.BaseOssUrl + data.resultObj.r_png; // 视频封面图
          this.videoSrc = localStorage.BaseOssUrl + data.resultObj.r_m3u8; // 视频全路径
          this.videoShortSrc = this.videoSrc.replace(localStorage.BaseOssUrl,'');
          this.loadingBut = false;
          this.loadingButText = '保存';
          this.videoFlag = false;
          this.videoUploadPercent = 0;
        } else {
          this.showAlert(data.resultMsg, 'error');
          this.videoFlag = false;
          this.videoUploadPercent = 0;
        }
      }).catch(error => {
        this.showAlert('上传失败', 'error');
      });
    },
    // 新版本上传oss预览
    newSeevideo(){
      if(this.videoSrc.indexOf("blob:") != -1){
        window.open(this.videoSrc);
      }else{
        this.palySeevideo(this.videoSrc);
      }
    },
    // 播放视频
    palySeevideo(url){
      this.videoVisible = true;
      this.playerOptions.sources[0].src = url;
    },
    closeVideo() {
      this.$refs.videoPlayer.player.pause();
    },
    // 删除视频操作
    delvideo() {
      this.$swal({
        type: "warning",
        text: "重要信息，确认删除视频吗？",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then((res) => {
        if (res.value) {
          this.videoImg='';
          this.videoSrc='';
          this.videoShortSrc='';
        }
      }).catch(() => {
        return;
      });
    },
    // 媒体素材类型 1=图片 2=视频
    handleplay(itemI) {
      if(itemI.mediatype ==1) {
        this.largeImage = true;
        this.showImageUrl = localStorage.BaseOssUrl + itemI.videoimg;
      }
      if(itemI.mediatype ==2) {
        this.palySeevideo(localStorage.BaseOssUrl + itemI.mediapath);
      }
    },
    // 商品详情
    contentChangeOne(content) {
      this.productProfile = content;
    },
    // 活动规则
    contentChangeTwo(content) {
      this.activityDesc = content;
    },
    // 活动主图 & 分享封面 & 商品图片
    beforUploadThree(file, type) {
      this.distinguish = type; // 区分
      if(type == 1){
        this.option.autoCropWidth = 1200;
        this.option.autoCropHeight = 675;
        this.option.fixedNumber = [1200, 675];
      }
      if(type == 2){
        this.option.autoCropWidth = 1000;
        this.option.autoCropHeight = 800;
        this.option.fixedNumber = [1000, 800];
      }
      const isSize = new Promise(function (resolve, reject) {
        let width = type==1?1200:type==2?1000:type==3?1200:type==4?1200:1200;
        let height = type==1?675:type==2?800:type==3?1200:type==4?675:675;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function () {
          let valid = img.width == width && img.height == height;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      })
      isSize.then(() => {
        var that = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async function (e) {
          that.handleOss(11); // oss 直传图片
          var newOssPic = await uploadOSS(file,0);
          if(type == 1) { // 活动主图
            that.groupWork.zbjbjUrl = newOssPic; // 全链接
            that.groupWork.zbjshortUrl = newOssPic.replace(localStorage.BaseOssUrl,'') // 短链接
          }
          if(type == 2) { // 分享封面
            that.groupWork.fxtpUrl = newOssPic; // 全链接
            that.groupWork.fxtpshortUrl = newOssPic.replace(localStorage.BaseOssUrl,'') // 短链接
          }
          if(type == 3) { // 商品图片
            that.groupWork.sltpUrl = newOssPic; // 全链接
            that.groupWork.sltpshortUrl = newOssPic.replace(localStorage.BaseOssUrl,'') // 短链接
          }
          if(type == 4) { // 活动主图-备份
            that.groupWork.hdztUrl = newOssPic; // 全链接
            that.groupWork.hdztshortUrl = newOssPic.replace(localStorage.BaseOssUrl,'') // 短链接
          }
          that.cropping = false; // 图片裁剪弹框
        };
      },() => {
        var that = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function(e) {
          // 上传成功后将图片地址赋值给裁剪框显示图片
          that.$nextTick(() => {
            that.option.img = e.target.result
            that.cropping = true; // 图片裁剪弹框
            if(type == 1) {
              setTimeout(()=>{
                // document.querySelector('.crop-info').setHTML("1200 x 675")
                document.querySelector('.crop-info').innerHTML = '1200 x 675'
              },300)
            }
            if(type == 2) {
              setTimeout(()=>{
                // document.querySelector('.crop-info').setHTML("1000 x 800")
                document.querySelector('.crop-info').innerHTML = '1000 x 800'
              },300)
            }
          })
          return
        };
        // this.showAlert(type==1?"上传图片宽高应为1200*675":type==2?'上传图片宽高应为1000*800':type==3?"上传图片宽高应为1200*1200":type==4?"上传图片宽高应为1200*675":'上传图片宽高应为1200*675');
      });
    },
    // 点击裁剪，这一步是可以拿到处理后的地址
    finish() {
      let that = this
      this.$refs.cropper.getCropBlob(data => {
        var canvas=document.getElementById("canvasa");
        var ctx=canvas.getContext("2d");
        let _URL = window.URL || window.webkitURL;
        var img=new Image();
        img.onload=start;
        img.src=_URL.createObjectURL(data);
        function start(){
          canvas.width=that.distinguish==1?1200:1000;
          canvas.height=that.distinguish==1?675:800;
          var w=img.width;
          var h=img.height;
          var sizer=Math.min((canvas.width/w),(canvas.height/h));
          ctx.drawImage(img,0,0,w,h,0,0,w*sizer,h*sizer);
          var dataURL = canvas.toDataURL('image/png');
          var getRes = dataURL;//读取的结果在result中
          function dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while(n--){
              u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, {type:mime});
          }
          var file = dataURLtoFile(getRes)
          that.beforUploadThree(file, that.distinguish)
        }
      })
    },
    // 商家联盟获取用户身份以及可查看的店铺
    tankuang(){
      let addParams = {
        userId: localStorage.Id, // 当前登陆人id
      };
      userIdentity(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            if(data.resultObj.length>1){
              // this.filters.shopid = data.resultObj[0].id; //店铺id
              // this.gonext();
              this.dialogVisibleadd = true;
              this.options1 = data.resultObj;
            } else { //默认选中第一个店铺不显示弹框
              this.dialogVisibleadd = false;
              this.filters.shopid = data.resultObj[0].id; // 店铺id
              this.bbtype = data.resultObj[0].shopType; // 店铺类型
              this.gonext();
            }
          }else{
            this.showAlert('请先在店铺信息功能中创建自己店铺');
            return false;
          }
        }
      })
    },
    // 获取店铺类型
    handleChangedptype(val) {
      this.options1.filter(item => {
        if(item.id == val){
          this.bbtype = item.shopType;
        }
      })
    },
    gonext(){
      if(this.filters.shopid == ""){
        this.showAlert('请选择店铺名称');
        return false
      }
      this.getInit(); // 查询列表
      this.dialogVisibleadd = false;
    },
    // 抽奖
    choujiang(row) {
      let pathInfo = this.$router.resolve({
        path:'/livelottery', // 直播抽奖
          query:{
            yyqid: row.flexibleCode,
            zbcjState: row.eventStatus, // 状态: 4 已结束
          }
      })
      window.open(pathInfo.href, '_blank');
    },

    // 重置
    chongzhiPz() {
      let params = {
        tasktype: 5, // 类型 1=分享赚钱-店铺充值 2=分享赚钱-活动充值  5=分享赚钱-幸运购
        shopid: this.filters.shopid, // 店铺ID
        activityid: Number(this.xygid), // 活动ID
      };
      delPeizhi(params).then(data => {
        if (data.resultCode == 1) {
          this.showAlert('操作成功', 'success');
          // this.recharge.totalcount = 0;
          this.seejlfsTwo = '';
        }
      });
    },
    getPeizhi(val) {
      let params={
        shopid: this.filters.shopid, // 店铺ID
        activityid: this.xygid?this.xygid:val, // 活动ID
      }
      configtaskType(params, 5).then(data => {
        if (data.resultCode == 1) {
          this.tasktyps = data.resultObj.tasktyps; // 任务类型集合
          this.recharge = data.resultObj.recharge; // 配置记录(充值单记录)
          this.fxdpyq = this.recharge.bttids?this.recharge.bttids[0]:this.tasktyps[0].bttid;
          this.rewardTwo = data.resultObj.univalence; // 单价 单位：元
          this.seejlfsTwo = data.resultObj.recharge.totalcount; // 赋值份数
          this.wxrate = data.resultObj.wxrate; // 微信手续费 默认0.006
          
          let hy = data.resultObj.filters.industry; // 行业ID集合
          if(hy[0]==0){
            this.formmenuOne = this.industry.map(item =>item.id); // 处理为全部选中状态
          }else {
            this.formmenuOne = hy;
            hy.length==5?this.isIndeterminateOne = false:this.isIndeterminateOne = true;
          }
          let pl = data.resultObj.filters.category; // 品类ID集合
          if(pl[0]==0){
            this.$refs.tree.setCheckedNodes(this.category); // 处理为全部选中状态
          }else{
            this.$refs.tree.setCheckedKeys(pl);
            this.isIndeterminateTwo = true;
          }
          
        }
      })
    },
    // 确定配置
    handleJxj() {
      let plarr=this.$refs.tree.getCheckedKeys(this.formmenuTwo).concat(this.$refs.tree.getHalfCheckedKeys());
      let params={
        tasktype: 5, // 类型 1=分享赚钱-店铺充值 2=分享赚钱-活动充值  5=分享赚钱-幸运购
        price: Number(this.rewardTwo), // 单份奖励
        num: Number(this.recharge.totalcount), // 份额
        remark: this.recharge.remark, // 分享文案(备注)
        shopid: this.filters.shopid, // 店铺ID
        activityid: Number(this.xygid), // 活动ID
        operatorid: Number(localStorage.Id), // 操作人id
        begintime: this.groupWork.ksTime, // 有效期-开始 格式：yyyy-MM-dd
        endtime: this.groupWork.jsTime, // 有效期-结束 格式：yyyy-MM-dd
        // bttids: this.fxdpyq==true?'1':[], // 任务类型ID 多个用英文逗号隔开
        bttids: this.fxdpyq, // 任务类型ID 多个用英文逗号隔开
        industry: this.formmenuOne, // 创客行业ID集合
        category: plarr, // 员工创客所属店铺品类ID集合
      }
      configSave(params).then(data => {
        if (data.resultCode == 1) {
          this.showAlert('配置成功', 'success');
          this.prizeCash = false; // 配置
          this.seejlfsTwo = this.recharge.totalcount; // 赋值奖励份数
        }
      })
    },
    /* oss 直传图片 */
    handleOss(val){
      let obj = { type: val };
      getOssFile(obj).then(data => {
        if (data.resultCode == 1) {
          let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
          let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
          let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
          let ossfile = data.resultObj.directory; // 保存路径
          let ossbucket = data.resultObj.bucket; // bucket
          localStorage.setItem('keyossId',ossId);
          localStorage.setItem('keyossSecret',ossSecret);
          localStorage.setItem('keyossHost',ossHost);
          localStorage.setItem('keyossfile',ossfile);
          localStorage.setItem('keyossbucket',ossbucket);
        }
      })
    },
    // 关闭el-image遮罩层
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        let domImageMask = document.querySelector('.el-image-viewer__mask')
        if (!domImageMask) {
          return
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
    
  },
  watch: {
    // 监听不予开奖
    'noLottery'(newV,oldV) {
      if(this.noLottery == true) {
        this.activeOrderList.map(item => item.zhongjiang = false)
      }
    },
    // 活动形式配置
    'xingshi'(nv,ov) {
      if(this.xingshi == 1) {
        this.groupWork.partake = ""; // 清空可参与人数
        this.groupWork.zjrs = ""; // 清空中奖名额
      } else {
        this.groupWork.cyrsmm = ""; // 清空参与人数每满
      }
    },
    // 单份奖励
    'rewardTwo'(newV,oldV) {
      this.recharge.totalprice = this.rewardTwo * this.recharge.totalcount;
    },
    // 奖励份数
    'recharge.totalcount'(newV,oldV) {
      // this.recharge.totalprice = this.rewardTwo * this.recharge.totalcount / (1 - this.wxrate);
      this.recharge.totalprice = this.rewardTwo * this.recharge.totalcount;
    }
  },
  created() {
    // this.getInit(); // 查询列表
    this.getBrandType();
    this.getprovince(); // 省+市
    this.tankuang(); // 商家联盟获取用户身份以及可查看的店铺
    this.getfilterlist(); // 获取树列集合
  }
}
</script>
<style scoped>
/* 详情页 */
.decorationDiaryDiv {
  width: 97%;
  margin: 0 auto;
  padding-top: 10px;
  border: 1px solid #eee;
}
/* 多图 */
.upPictures {
  width: 100%;
}
.multigraph {
  width: 80px;
  height: 80px;
  background: cornflowerblue;
  position: relative;
  float:left;
  margin-right:10px;
  margin-bottom: 5px;
  margin-top:5px;
}
.upBtn {
  width: 80px;
  height: 80px;
  line-height: 80px;
  border: 1px solid #DCDFE6;
  font-size: 26px;
  color: #999;
  margin-top:5px;
}
/* 弹框内容布局 */
/* 开奖 */
.lotteryStyle {
  width: 100%;
  display:flex;
  justify-content: space-between;
}
.infoCheckStyle {
  width: 36%;
  display:flex;
  justify-content: space-between;
}
.classWinnerStyle {
  width: 60%;
  height: 40px;
  line-height: 40px;
  margin-bottom: 10px;
  display:flex;
  justify-content: space-between;
}
/* 复制活动 & 派奖 */
.formItem {
  width: 100%;
  display:flex;
  justify-content: space-between;
}
.classPrize {
  width: 100%;
  height: 40px;
  margin-bottom: 10px;
  display:flex;
  justify-content: space-between;
}
.kjmc {
  width: 100px;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.dizhi {
  width: 90px;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
/* 重要提示 */
.zyts {
  width: 100%;
  font-size: 13px;
  color: #F56C6C;
}
/* 详情页 - 提示 */
.redTishi {
  float: right;
  margin-top: 16px;
}
.redTishi>span {
  color: #999;
  margin-right: 40px;
}
.redTishi>span:last-child {
  color: #F56C6C;
}
/* 参与信息 - 文案 */
.canyuxinxi {
  width: 99%;
  height: 40px;
  line-height: 40px;
  margin: 5px 0 10px 10px;
  display:flex;
  justify-content: space-between;
}
/* 加粗标题 */
.boldTitle {
  font-weight: 700;
  font-size: 16px;
  color:#333;
  margin-left: 22px;
}
.threePrice {
  font-weight: normal;
  font-size: 13px;
  margin-left: 30px;
}
/* 视频 & 图片 集合 */
.videoandpic {
  width: 96%;
  margin: 10px auto;
  padding-left: 0;
  position: relative;
  display: inline-block;
}
.videoandpic>li{
  float: left;
  margin: 0 10px 5px 0;
  cursor: pointer;
  position: relative;
}
.mengceng {
  position: absolute;
  left: 30px;
  top: 30px;
  font-size: 40px;
  color: #666;
}
/* 推广记录 - 温馨提示 */
.reminder{
  margin: 0 0 10px 5px;
  font-size: 14px;
}
.redClass {
  color: #F56C6C;
}
/* 文本超出 */
.textexceeds{
  width:200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inline-block;
  float: right;
  margin-left: 10px;
}
</style>


// WEBPACK FOOTER //
// shoppingActivities.vue?6ab837aa